import React from 'react'
import { gql, graphql } from 'react-apollo'

import {
  Loading,
  Form,
  Notifications,
} from 'components/UI'

const UserOrganizationList = ({ data, onChange, selection }) => {
  if (data.error) return <Notifications.Error message={data.error.message} />
  if (data.loading) return <Loading />

  const organizations = data.organizations.map(org => ({
    id: org.id,
    label: org.name,
  }))

  return (
    <Form.RadioList
      onChange={onChange}
      items={organizations}
      selection={selection}
    />
  )
}

const UserOrganizationListQuery = gql`
  query UserOrganizationListQuery {
    organizations {
      id
      name
    }
  }
`

export default graphql(UserOrganizationListQuery, {
  options: {
    notifyOnNetworkStatusChange: true,
  },
})(UserOrganizationList)



// WEBPACK FOOTER //
// ./src/components/Profile/UserOrganizationList.jsx